import { render, staticRenderFns } from "./DialogExibirErrosImportacao.vue?vue&type=template&id=0fd38baf&scoped=true&"
import script from "./DialogExibirErrosImportacao.vue?vue&type=script&lang=js&"
export * from "./DialogExibirErrosImportacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd38baf",
  null
  
)

export default component.exports